import { z } from 'zod/v4';

export const integrationTypeOptions = [
  'None',
  'MobileDeviceId',
  'DriverId',
  'VehicleId',
] as const;

export const integrationTypeSchema = z.enum(integrationTypeOptions);

export type IntegrationType = z.infer<typeof integrationTypeSchema>;
